<template>
	<div class="concierce_wrapper">
		<!-- contents-->
		<div class="contents">
			<div class="voucher_post_box">
				<div class="voucher_post">
					<img src="./images/concierce_voucher_mo.png" alt="DIAMOND DONCIERGE PHYTO CAFE 음료바우처">
				</div>
			</div>			
			<div class="voucher_info_box">
				<h2 class="title">
					파이토 카페 음료와 함께<br>
					건강한 웰니스 에너지 충전
				</h2>
				<div class="voucher_info_inner">
					<div class="voucher_info_sub">장소</div>
					<p class="voucher_info_txt">파이토 카페가 있는 전국 ABC/A STATION </p>
					<span>(분당/강서/인천/대전/울산/부산/창원/전주 ABC 및 A STATION) </span>
				</div>
				<div class="voucher_info_inner">
					<div class="voucher_info_sub">이용기한</div>
					<p class="voucher_info_txt">{{this.makeDateFormat(this.end_date)}}</p>
				</div>
                <div class="voucher_info_inner">
                    <div class="voucher_info_sub">이용안내</div>
                    <ul class="voucher_info_list">
                        <!-- S : 20221005 수정-->
                        <li>바우처 1장당 음료 한잔 (3,500원 가격) 선택이 가능합니다. (베이커리, 스낵 제외)</li>
                        <li>3,500원 이상 음료 선택 시, 추가 금액은 별도 결제 가능합니다. (3,500원 미만 음료는 차액 지불 미적용)</li>
                        <li>바우처는 현금으로 교환 및 잔액 환불이 불가합니다.</li>
                        <li>음료 선택 후, 파이토 카페 직원에게 바우처를 제시해 주시기 바랍니다.</li>
                        <!-- E : 20221005 수정-->
                    </ul>
                    <!-- S : 20221005 추가 -->
                    <div class="voucher_info_inner">
                        <div class="voucher_info_sub">유의사항</div>
                        <ul class="voucher_info_list">
                            <li>이용기한은 바우처 표기기한까지 입니다.</li>
						    <li>이용기한 내 바우처 미사용 시, 분실 시 재발급 불가합니다.</li>
						    <li>바우처가 포함된 메시지 삭제 시, 재발송 불가합니다.</li>
                            <li>바우처 선물 받으실 분의 휴대폰 번호를 정확히 입력해 주시기 바랍니다. 바우처 발송 후 회수 및 취소 불가합니다.</li>
						    <li>양도/양수 가능합니다.</li>
                        </ul>
                    </div>
                    <!-- E : 20221005 추가 -->
                </div>
			</div>
			<div class="voucher_greet" v-show="isProud">
				<p class="greet_sub">“I’M PROUD OF YOU”</p>
				<p class="greet_txt">당신이 자랑스럽습니다.</p>
				<div class="greet_sender">
					<span class="sender">{{this.abo_name}}</span>님이 보내신 선물입니다.
				</div>
			</div>
			<div class="voucher_coupon_agree_box" v-show="!isNext">
				<div class="voucher_coupon_agree">
					<div class="coupon_agree_all">
						<input type="checkbox" @change="checkedAll($event)" v-model="allChecked" id="form_agree_all_coupon" class="form_agree">
						<label for="form_agree_all_coupon">파이토 카페 음료 바우처 이용약관 동의</label>
					</div>
					<div class="coupon_agree_detail">
						<div class="coupon_agree_detail_inner">
							<input type="checkbox" @change="check($event)" v-model="checkList[0]" id="form_agree_1" class="form_agree">
							<label for="form_agree_1">[필수] 파이토 카페 음료 바우처 이용동의</label>
							<a @click="termsPopup(true,'voucher')" class="agree_detail_pop" data-layer="voucher-agree-layer">자세히 보기</a>
						</div>
						<div class="coupon_agree_detail_inner">
							<input type="checkbox" @change="check($event)" v-model="checkList[1]" id="form_agree_2" class="form_agree">
							<label for="form_agree_2">[필수] 개인정보 수집 및 이용동의</label>
							<a @click="termsPopup(true,'personal')" class="agree_detail_pop" data-layer="personal-agree-layer">자세히 보기</a>
						</div>
					</div>
				</div>
			</div>

            <!-- S : 직원 확인 버튼 클릭 시 노출 -->
            <!-- <div class="voucher_contact"> -->
            <div class="voucher_contact" v-show="exchange">
                <p>매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.</p>
                <div class="contact_tel">
                    <div class="contact_tel_1">
                        <select class="form-tel" title="ABC 지역 입력" @change="selectBoxChange($event)">
                            <option :key="i" :value="storeInfo.store_code" v-for="(storeInfo,i) in storeInfo">{{ storeInfo.store_name }} ABC</option>
                        </select>
                    </div>
                    <div class="contact_tel_2">
                        <input v-model="store_pw" type="password" class="form-tel" placeholder="****" title="비밀번호 입력">
                    </div>
                </div>
            </div>
            <!-- E : 직원 확인 버튼 클릭 시 노출 -->

            <div class="concierce_btn_area">
                <!-- 바우처 교환 전 case-->
                <button type="button" class="btn-pop-submit"  v-show="exchange" v-on:click="exchangeCoupon()">바우처 교환 완료 처리</button>
                <!-- 바우처 교환 완료 case -->
                <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
                <!-- 바우처 사용 기한 만료 case -->
                <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
            </div>

			<div class="concierce_btn_area">                
				<button type="button" class="btn-pop-submit" v-show="!isNext" v-on:click="next()">이용동의 및 직원확인</button>
                <button type="button" class="btn-pop-submit" v-show="isCancel" disabled>회수된 바우처</button>                
                <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
                <!-- 바우처 교환 완료 case -->
                <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
			</div>
		</div>
        <!-- S : 20220816 바우처 이용 동의 팝업 -->
        <div id="voucher-agree-layer" class="layer-area layer_section type-narrow-b"  :class="{showing:popupFlag1}" >
            <div class="layer_section-container">
                <div class="layer-content">
                    <!-- S : 20221005 수정-->
                    <div class="agree-area">
                        <div class="agree-title-area">
                            <h1 class="agree-title">파이토 카페 음료 바우처 이용동의</h1>
                        </div>
                        <div class="agree-content">
                            <ol>
                                <li>파이토 카페 음료 바우처는 한국암웨이 다이아몬드 이상 리더에게 제공되는 다이아몬드 컨시어지 혜택입니다.</li>
                                <li>다이아몬드 컨시어지 혜택자에게 선물받은 바우처는 판매가 불가능하며, 소비자로서 최종 소비만 가능합니다.</li>
                                <li>이용기한내에 바우처를 사용하시길 권장드립니다.</li>
                                <li>바우처 이용기한내 미사용 시, 분실 시 재발급 불가합니다.</li>
                                <li>바우처가 포함된 메시지 삭제 시 재발송 불가합니다.</li>
                            </ol>
                        </div>
                    </div>
                    <!-- E : 20221005 수정-->                    
                </div>
                <div class="align-box size-auto">
                    <button @click="termsPopup(false,'voucher')" type="button" class="btn-modal_close">확인</button>
                </div>
            </div>
        </div>
        <!-- E : 20220816 바우처 이용 동의 팝업 -->

        <!-- S : 20220816 개인정보수집및이용동의 팝업 -->
        <div id="personal-agree-layer" class="layer-area layer_section type-narrow-b" :class="{showing:popupFlag2}">
            <div class="layer_section-container">
                <div class="layer-content">
                    <div class="agree-area">
                        <div class="agree-title-area">
                            <h1 class="agree-title">개인정보 수집 및 이용동의</h1>
                        </div>
                        <div class="agree-content">
                            <p>한국암웨이㈜는 다이아몬드 컨시어지 파이토 카페 음료 바우처 제공을 위하여 다음과 같이 귀하의 개인정보를 수집 및 이용합니다.</p>
                            <ul class="agree-list">
                                <li>
                                    수집하는 개인정보 항목
                                    <span>성명, 전화번호</span>
                                </li>
                                <li>
                                    개인정보의 수집 및 이용목적
                                    <span>파이토 카페 음료 바우처 발행</span>
                                </li>
                                <li>
                                    개인정보의 보유 및 이용기간
                                    <span>동의일로부터 6개월</span>
                                </li>
                            </ul>
                            <p>※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 다이아몬드 컨시어지 파이토 카페 음료 바우처 혜택은 제공되지 않습니다.</p>
                        </div>
                    </div>
                </div>
                <div class="align-box size-auto">
                    <button @click="termsPopup(false,'personal')" type="button" class="btn-modal_close">확인</button>
                </div>
            </div>
        </div>
	    <!-- E : 20220816 개인정보수집및이용동의 팝업 -->
	</div>
</template>


   
<script>

// Library
import Vue from 'vue'
import axios from 'axios'
import querystring from 'querystring'
import $ from 'jquery'
import { async } from 'q'


export default {
    metaInfo: {
    title: '다이아몬드 컨시어지 파이토 카페 바우처 선물하기',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'NY Fee Bundle'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'한웨이님이 선물하신 ABC 파이토 카페 음료 바우처를 사용해 보세요.'},
        { property:'og:image', content:'./images/concierce_kakao_thumb.png'}
    ]
    },
    name: 'giftCoupon',
    components: {

    },
    data () {
        return {
            isConfirm : true,
            isExchanged : false,
            isExchangeSuccess : false,
            isExpired : false,
            ready: false,
            storeInfo : [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}],
            end_date : '',
            store_pw : '',
            checkList : [false,false],
            allChecked: false,
            isNext : false,
            isProud : true,
            isCancel : false,
            abo_name : '한국암웨이',
            popupFlag1 : false,
            popupFlag2 : false,
            scrollLock: false,
            secretKey: String,
	            cryptoData: {
	                username: 'AmwayKorea',
	                id: '7480003',
	                password: '1234'
            },
            inProgress : false
        }
    },
    computed:{
        confirm(){
           return this.isConfirm 
        },
        exchange(){
            return this.isExchanged
        },
        exchangeSuccess(){
            return this.isExchangeSuccess
        },
        expired(){
            return this.isExpired   
        }
    },
    methods: {
        init: function () { // 초기화
            
            // storeInfo
            this.storeInfo = [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}]
            
            // button visibility
            this.isConfirm = false
            this.isExchanged = false
            this.isExchangeSuccess = false
            this.isExpired = false
            this.nowdate = ''
            
            this.getStoreInfo()

            // param
            this.store_code = ''
            this.store_pw = ''
            this.confirmResult = ''

            // 받아야 할 parameter
            // target_user_id 는 sentCouponID를 통해서 구해와야 한다.

            // 사용처리시 필요한 param
            // sent_coupont_id(gift), target_user_id(my), store_code, pin_num,gift (my or gift)            
        },
        makeDateFormat:function(tDate){
            if(tDate){
                const dt = new Date(tDate);
                return dt.getFullYear()+"년 "+(dt.getMonth()+1)+"월 "+dt.getDate()+"일 까지";
            }
        },        
        termsPopup: function(flag, what){
            if (what === 'voucher'){
                this.popupFlag1=flag;
            }else if (what === 'personal'){
                this.popupFlag2=flag
            }
            //this.scrollLock=flag;
            if(flag){
                document.documentElement.style.overflow = 'hidden'
            }else{
                document.documentElement.style.overflow = 'auto'
            }     
        },
        // 체크박스 전체선택 해제 start
        checkedAll: function(e) {
            this.allChecked = e.target.checked
            for (let i in this.checkList) {
                this.checkList[i] = this.allChecked;
            }
        },
        check: function(e){
            for (let i in this.checkList) {
                if(! this.checkList[i]) {
                    this.allChecked = false;
                    return;
                } else {
                    this.allChecked = true;
                }
            }
        },
        // 체크박스 전체선택 해제 end
        next: function(){
            // 약관 미확인 시 넘어가지 않음
            for (let i in this.checkList) {
                if(! this.checkList[i]) {
                    alert('바우처 사용 동의 약관을 확인해주세요.')
                    return;
                }
            }
            this.isNext = true;
            this.isProud = false;

            this.isExchanged = true
            setTimeout(function () {
                $(".concierce_wrapper")[0].scrollIntoView({behavior : "smooth", block : "end", inline: "end"})
                }, 100
            )

        },
        selectBoxChange: function(event){
            this.store_code = event.target.value
        },
        exchangeCoupon: async function(){
            if(this.inProgress === false){
                this.inProgress = true
                if(this.store_pw == ''){
                    alert('비밀번호를 입력하여 주십시오.')
                }else{                
                    await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-useCoupon', {            
                        scid:this.cpNo,
                        tuid:'',
                        store_cd : this.store_code,
                        pin_num : this.store_pw,
                        gift:'gift',
                        useCnt: 1, // lambda 를 공통으로 만들었고 추후 요건이 추가될 경우 대비해서 뚫어둠 (현재는 의미 없음)
                        created_by : 'SYSTEM',
                        modified_by : 'SYSTEM'
                    }, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                    }).then(response => {
                    console.log('response : ', JSON.stringify(response, null, 2))            
                    if (response.data.statusCode === 200) {
                                        
                        this.confirmResult = JSON.parse(response.data.results)
                        console.log(this.confirmResult[0].resultCode)
                        if(this.confirmResult[0].resultCode === "PIN FAULT"){
                            alert('비밀번호를 다시 확인해주세요.')
                        }else if(this.confirmResult[0].resultCode === "STORE INVALID"){
                            alert('store Invalide')
                        }else if(this.confirmResult[0].resultCode ==="SUCCESS"){
                            alert('교환 완료')
                            
                            // ABC Select box, 쿠푼교환 완료처리 버튼 숨김
                            this.isExchanged = false
                            // 교환완료 버튼 노출 및 disabled 처리
                            this.isExchangeSuccess = true

                        }else if(this.confirmResult[0].resultCode ==="COUPON EXPIRED"){
                            alert('유효기간이 만료 되었습니다.')
                        }
                    } else {
                        alert('500')
                    }
                    }).catch(error => {
                        console.log('error : ', error)
                        alert('잠시후 다시 시도 부탁드립니다.')
                    })
                }
            }
            this.inProgress = false   
        },
        // store정보
        getStoreInfo: function () {
            axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-myCoupon', {
                'scid' : this.cpNo,
                'tuid' : ''
            }, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
            }).then(response => {
            console.log('response : ', JSON.stringify(response, null, 2))            
            if (response.data.statusCode === 200) {
                this.storeInfo = JSON.parse(response.data.storeList)
                if(this.storeInfo.length > 0){
                    this.store_code = this.storeInfo[0].store_code                
                }
                this.cpInfo = JSON.parse(response.data.couponInfo)
                if(this.cpInfo.length > 0){
                    this.abo_name = this.cpInfo[0].abo_name
                    this.endDate = this.cpInfo[0].end_date
                    this.use_yn = this.cpInfo[0].use_yn
                    if(this.use_yn == 'C'){
                        //회수된 바우처 처리
                        this.isCancel = true
                        this.isNext = true
                        this.isProud = false
                    }else if(this.use_yn == 'Y'){
                        this.isExchangeSuccess = true
                        this.isNext = true
                        this.isProud = false
                    }
                }else{
                    alert('존재하지 않는 바우처입니다.')                    
                    window.location.href = "https://www.amway.co.kr"

                }
                if(this.endDate == null){
                    this.endDate = ''
                }            
                
                //this.endDate = '2022-12-18 10:35:44'
                this.end_date = this.endDate.substring(0, 10)            
                this.cpyear = this.endDate.substring(0,4)
                this.cpmonth = this.endDate.substring(5,7)
                this.cpdate = this.endDate.substring(8,10)
                

                // 연도, 월, 일 추출
                const js_date = new Date();
                const cpdate = new Date(this.cpyear, this.cpmonth-1, this.cpdate)
                const nowdate = new Date(js_date.getFullYear(),js_date.getMonth(),js_date.getDate());

                // 유효기간 만료시 버튼 처리
                if(cpdate >= nowdate){
                    this.isExpired = false
                }else{
                    this.isExpired = true
                    this.isConfirm = false
                    this.isExchanged = false
                    this.isExchangeSuccess = false
                    this.isNext = true
                    this.isCancel = false
                }
                
            } else {
                alert('Fail to load store info')
            }
            }).catch(error => {
                console.log('error : ', error)
                alert('잠시후 다시 시도 부탁드립니다.')
            })
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.ready = true
            this.init()
            }, 100)
    },
    created() {
        this.cpNo = this.$route.params.cpNo
    }
}
</script>

<style>
    @import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/giftCoupon.vue